import React from "react";
var __jsx = React.createElement;
import { Fragment } from "react";
import { renderHeadlessComponent } from "@/pages/financing/FinancingPageRoot";
import { useLang } from "@/common/Contexts/LanguageContext";
import HeroArea from "@componentsShared/HeroArea/HeroArea";
import { financeButtonColorHelper, financeImageHelper, financeUrlHelper } from "@/pages/financing/helpers/financingHelpers";
import { ComponentType } from "@type/models/cms";
import EligibilityComponent from "@/_MiniApps/EligibilityComponent/EligibilityComponent";
import useIsMobile from "@hooks/useIsMobile";
import useIsWebView from "@hooks/useIsWebview";
export var FinanceLandingHero = function FinanceLandingHero(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    cta = _ref.cta,
    image = _ref.image;
  var lang = useLang();
  return /*#__PURE__*/React.createElement(HeroArea, {
    title1: title,
    subTitle: subtitle,
    image: financeImageHelper(image.url),
    imageCaption: image.caption,
    backGroundColor: "#3C56D4",
    buttonText: cta.text,
    buttonColor: financeButtonColorHelper(cta.type),
    url: financeUrlHelper(cta.url, lang),
    newTab: cta.newTab
  });
};
var validComponents = [ComponentType.HERO, ComponentType.BENEFITS_LIST, ComponentType.PROCESS_STEPS, ComponentType.BROWSE_FINANCING, ComponentType.BROWSE_CARS, ComponentType.ABOUT_SYARAH, ComponentType.NEED_HELP, ComponentType.BREADCRUMB, ComponentType.BANKS_GROUP];
var FinanceLanding = function FinanceLanding(financingPageResponse) {
  var isMobile = useIsMobile();
  var isWebView = useIsWebView();
  return financingPageResponse.financePage.contentSections.filter(function (section) {
    return validComponents.includes(section.__component);
  }).map(function (section, index) {
    return /*#__PURE__*/React.createElement(Fragment, {
      key: index
    }, (section === null || section === void 0 ? void 0 : section.__component) === "sections.benefits-list" && ((section === null || section === void 0 ? void 0 : section.id) === 2 || (section === null || section === void 0 ? void 0 : section.id) === 8) && /*#__PURE__*/React.createElement(React.Fragment, null, !isMobile && /*#__PURE__*/React.createElement("div", {
      className: "max-w-[1100px] my-20 mx-auto"
    }, /*#__PURE__*/React.createElement(EligibilityComponent, {
      design: "banner",
      entryPoint: "seo_finance_page",
      skipFlag: true
    })), isMobile && !isWebView && /*#__PURE__*/React.createElement("div", {
      className: "max-w-[90%] my-20 mx-auto"
    }, /*#__PURE__*/React.createElement(EligibilityComponent, {
      design: "card",
      entryPoint: "seo_finance_page",
      skipFlag: true
    }))), renderHeadlessComponent(financingPageResponse, section));
  });
};
export default FinanceLanding;